ajaxifyCollection = function(isSearch){
	//code borrowed from https://github.com/Elkfox/Ajaxify
	var linkParent = '.pagination-ajax'; // Class of pagination container
	var parentContainer = '.template-flex-layout-content'; // All of the content selector used to detect scroll bottom distance
	var endlessScrollContainer = '.EndlessScroll'; // Selector for endless scroll pages
	var endlessOffset = 700; // Offset the distance from the bottom of the page
	var ajaxinateContainer = '.Ajaxinate'; // ID Selector for ajax pagination pages
	var ajaxinateLink = '.page a'; // Class Selector for ajax pagination links
	var fade = 'fast'; // fade speed
	var textChange = 'Loading'; // Text whilst loading content

	var linkElem;
	var contentContainer;
	var pageNumber;
	var pageType;
	var action;
	var moreURL;
	var moreURLCheck;
	var currentPage;

	var gettingContent = false;

	var maxPages = $('.pagination-ajax').data('pages');

	var loadedLastPage = false;

	$.loadMore = function() {
//       console.log('loadmore');
		if(isSearch && moreURL !== undefined) {
			moreURLCheck = moreURL.substring(moreURL.lastIndexOf("?page=")+1,moreURL.lastIndexOf("&q="));
			moreURLCheck = moreURLCheck.split("page=");
			currentPage = moreURLCheck[1];
		}
		else if (isSearch != true && moreURL !== undefined) {
			moreURLCheck = moreURL.split("page=");
			currentPage = moreURLCheck[1];
		}
		else {
			currentPage = null;
		}
      

	   if (currentPage != null && moreURL.length && currentPage <= maxPages && loadedLastPage == false){
		   $(linkElem).css('opacity', 0);
		   $('.loader').show();
		   gettingContent = true;
		 $.ajax({
		   type: 'GET',
		   dataType: 'html',
		   url: moreURL,
		   success: function(data) {
			if(currentPage == maxPages) {
				loadedLastPage = true;
			}
			// $(".pagination-ajax").css("position", "absolute");
			// $(".loader").css("position", "absolute");

			var filteredData = $(data).find(contentContainer);

			var filteredDataProducts = filteredData[0].innerHTML;

			var newProdHtml = $(filteredDataProducts);

			var newPagination = $(data).find(".pagination-ajax");

			$(contentContainer).append(newProdHtml).hide().fadeIn(fade);

			$(".pagination-ajax").html(newPagination);

			SPR.registerCallbacks();
			SPR.initRatingHandler();
			SPR.initDomEls();
			SPR.loadProducts();
			SPR.loadBadges();


			var newProducts = newProdHtml;

			 ModalQuickShop();

			 $(linkElem).css('opacity', 0);
			 $('.loader').hide();
			 gettingContent = false;
			 if (pageType == 'endlessScroll') {
			   $.endlessScroll();
			 }
		   },
    		timeout:15000,
			error: function(jqXHR, textStatus, errorThrown) {
				$('.loader').hide();
		        if(textStatus==="timeout") {
					$(linkElem).text("Load more");
					$(linkElem).css('opacity', 1);
		        }
		    }
		 });
	   }
	 };


	 $.endlessScroll = function() {
	  action = 'scroll load resize';
	  $(".template-flex-layout-content").on( action, function() {
        // console.log('endlessscroll');
		contentContainer = endlessScrollContainer;
		moreURL = $(linkElem).last().attr('href');
		pageType = 'endlessScroll';
		$(linkElem).text(textChange);

		var bottom;
		var docTop;

		if ($(contentContainer+':last-of-type '+linkElem).length || $(contentContainer).length == 1){
			if($(contentContainer).length == 1) {
				moreURL = $(linkElem).last().attr('href');
			}
			else {
				moreURL = $(linkElem).last().attr('href');
			}
		  bottom = $( ".collection-section" ).outerHeight();
		  docTop = ($(parentContainer).scrollTop() + endlessOffset);
		  
          if( docTop > bottom && gettingContent == false) {
			$(window).off(action);
			  $.loadMore();
		  }
		}
	  });
	};

	if ( $( endlessScrollContainer ).length ) {
	  linkElem = linkParent+' a';
	  $.endlessScroll();
	}
};
